<script lang="ts">
  import type { ButtonLinkStoryblok } from "$types/components";
  import Button from "$lib/atoms/Button.svelte";
  import { IconType } from "$types/atoms";
  import { ButtonColor } from "$types/atoms";

  export let blok: ButtonLinkStoryblok;

  export let icon: IconType | null = null;
  export let isLight = false;
  export let color = null;
  export let reduced = false;

  $: buttonColor = color ?? blok.color;
  $: buttonIcon = icon ?? (blok.arrow ? IconType.ARROW_RIGHT : null);
</script>

<Button
  href={blok.url}
  target={blok.url?.target}
  icon={buttonIcon}
  {reduced}
  rounded={blok.rounded}
  color={buttonColor
    ? buttonColor
    : isLight
      ? ButtonColor.WHITE
      : ButtonColor.BLACK}>{blok.text}</Button
>
